import { Component, OnInit } from '@angular/core';
import { StateService } from '../../services/state.service';
import { VehicleService } from '../../services/vehicle.service';

@Component({
  selector: 'app-fleet-list',
  templateUrl: './fleet-list.component.html',
  styleUrls: ['./fleet-list.component.css']
})
export class FleetListComponent implements OnInit {

  vehicles:any = [];
  listedVehicles:any = [];
  vehicleGroups:any = [];
  vehicleStatusGroups:any = [];
  initState = true;
  filterList = 'All';
  user:any = {};
  showMultipleOnMap = true;
  addShow = true;
  map:any = {};
  
  constructor(private stateSvc: StateService, private vehicleSvc: VehicleService) { }

  ngOnInit(): void {
	// get user info from session
	let userString = sessionStorage.getItem('user');
	// parse into JSON format, local only store as single string
	this.user = JSON.parse(userString);
	this.stateSvc.mapInstance
	.subscribe((map) => {
		this.map = map;
	});
	this.stateSvc.vehicles
	.subscribe((result) => {
		this.vehicles = result;
		if(this.initState){
			//this.stateSvc.setVehicleFiltered(result);
		}
		if(this.filterList != 'All'){
			this.filterChanged(this.filterList)
		}else{
			this.stateSvc.setVehicleFiltered(result);
		}
		this.stateSvc.vehicleStatusGroups
		.subscribe((statuses) => {
			this.vehicleStatusGroups = statuses;
		});
		this.stateSvc.vehicleGroups
		.subscribe((groups) => {
			this.vehicleGroups = groups;
		});
		if(result?.length > 0){
			this.initState = false;
		}

		setTimeout(() => {
			if(localStorage.getItem('jump_direct')){
				let searchedVhc:any = JSON.parse(localStorage.getItem('jump_direct'));console.log('searchedVhc',searchedVhc)
				
				let vchUnitId = searchedVhc?.unitid? searchedVhc.unitid : searchedVhc.terminalNo;
				var $scrollableDiv:any = $('#scrollable-div');
				var $targetElement:any = $('#' + vchUnitId);

				var isHoriScroll = $('#scrollable-div').css('overflow-x');

				if(isHoriScroll == 'hidden'){
					// Calculate the target scroll position
					var targetOffset = $targetElement?.offset()?.top - $scrollableDiv?.offset()?.top + $scrollableDiv?.scrollTop();
					// Animate the scroll
					$scrollableDiv.animate({
						scrollTop: targetOffset
					}, 800); // 800 milliseconds for smooth animation
				}else{
					// Calculate the target scroll position
					var targetOffset = $targetElement?.offset()?.left - $scrollableDiv?.offset()?.left + $scrollableDiv?.scrollLeft();
					$scrollableDiv.animate({
						scrollLeft: targetOffset
					}, 800); // 800 milliseconds for smooth animation
				}

				setTimeout(() => {
					this.toggleShownOnMap(searchedVhc, true);
				},700);
				
				localStorage.removeItem('jump_direct');
			}
		}, 3300);
	});
	this.stateSvc.vehicleFiltered
	.subscribe((filtered) => {
		this.listedVehicles = filtered;
	});
	this.stateSvc.dropDownFilterValue
	.subscribe((dropdownValue) => {
		this.filterList = dropdownValue;
	});
	this.stateSvc.showMultipleOnMap
	.subscribe((result) => {
		this.showMultipleOnMap = result;
	});
	this.stateSvc.rightStatusTrigger
	.subscribe((newStatus) => {
		this.filterChanged(newStatus);
	});
  }
  
  showMapInfoWdw(vehicle, ev){
	let currentMapProvider = this.stateSvc.getMapType();
	if(ev.target.checked){
		vehicle.toggleInfoWdw = true;
		if(!vehicle.shownOnMap){
			this.toggleShownOnMap(vehicle, true);
		}
		if(currentMapProvider == "Google"){
			if (!vehicle.infoWindow.shown) {
				if(vehicle.marker?.map != this.map){
					vehicle.marker.setMap(null);
					vehicle.marker.setMap(this.map);
					vehicle.infoWindow = new google.maps.InfoWindow({
						content: vehicle.infowWindowContent
					});
					vehicle.infoWindow.shown = true;
					google.maps.event.clearListeners(vehicle.marker, 'click');
					vehicle.marker.addListener('click', () => {
						if (!vehicle.infoWindow.shown) {
							vehicle.infoWindow.open(vehicle.marker?.map, vehicle.marker);
							vehicle.infoWindow.shown = true;
							vehicle.toggleInfoWdw = true;
						} else {
							vehicle.infoWindow.close();
							vehicle.infoWindow.shown = false;
							vehicle.toggleInfoWdw = false;
						}
					});
					google.maps.event.addListener(vehicle.infoWindow,'closeclick',() => {
						vehicle.infoWindow.shown = false;
						vehicle.toggleInfoWdw = false;
					});
				}
				vehicle.infoWindow.open(vehicle.marker?.map, vehicle.marker);
				vehicle.infoWindow.shown = true;
			}
		}else{
			vehicle.marker.bindPopup(vehicle.infowWindowContent).openPopup();
		}
	}else{
		vehicle.toggleInfoWdw = false;
		if(currentMapProvider == "Google"){
			if (vehicle.infoWindow.shown) {
				vehicle.infoWindow.close();
				vehicle.infoWindow.shown = false;
			}
		}else{
			vehicle.marker.closePopup();
		}
	}
  }
  
  toggleShownOnMap(vehicle, multiple){
	let vhcUnitId = vehicle?.unitid? vehicle.unitid : vehicle.terminalNo;
	this.vehicleSvc.updateVehicleOnMap(this.vehicles, this.listedVehicles, vhcUnitId, this.map);
	console.log('after', this.vehicles);
	// console.log('mapphamarker', this.map.hasLayer(vehicle.marker))
	this.stateSvc.setMapLoaded(true);
	this.stateSvc.setVehicles(this.vehicles);
  }

  toggleShownOnMapSearched(vehicle, multiple){
	this.vehicleSvc.updateVehicleOnMap(this.vehicles, this.listedVehicles, vehicle.unitid, this.map , true);
	this.vehicles.forEach((vhc) => {
		if(vhc.unitid == vehicle.unitid){
			console.log('afterSe', vhc)
		}
	})
  }
  
  filterChanged(selectValue){
	let result = [];  
	switch (selectValue) {
		case 'Selected':
			result = this.filterVehicleByShownOnMap();
			break;
		case 'All':
			result = this.vehicles;
			break;
		case 'Active':
			result = this.filterVehicleByStatus('active');
			break;
		case 'Idle':
			result = this.filterVehicleByStatus('idle');
			break;
		case 'Stop':
			result = this.filterVehicleByStatus('stop');
			break;
		default:
			result = this.filterVehicleByGroup(selectValue);
			break;
	}
	this.stateSvc.setDropDownFilterValue(selectValue);
	this.stateSvc.setVehicleFiltered(result);
  }
  
  filterVehicleByStatus(status){
	let tmpResult = [];
	this.vehicles?.forEach((vehicle) => {
		if(vehicle.status == status){
			tmpResult.push(vehicle);
		}
	});
	
	return tmpResult;
  }
  
  filterVehicleByGroup(selectValue){
	let tmpResult = [];
	this.vehicles?.forEach((vehicle) => {
		if (vehicle.groupname == selectValue) {
			tmpResult.push(vehicle);
		}
	});
	
	return tmpResult;
  }
  
  filterVehicleByShownOnMap(){
	let tmpResult = [];
	this.vehicles?.forEach((vehicle) => {
		if (vehicle.shownOnMap) {
			tmpResult.push(vehicle);
		}
	});
	
	return tmpResult;
  }
  
  showAllVehicles(ev){
	if(ev.target.checked){
		this.vehicles.forEach((vehicle,key) => {
			if(!vehicle.shownOnMap){
				this.toggleShownOnMap(vehicle, true);
			}
		});
	}else{
		this.vehicles.forEach((vehicle,key) => {
			if(vehicle.shownOnMap){
				this.toggleShownOnMap(vehicle, true);
			}
		});
	}
  }
  
  searchingType(e){
	let tmpResult = [];
	this.vehicles?.forEach((vehicle) => {
		if (vehicle.description.toLowerCase().indexOf(e.toLowerCase()) > -1) {
			tmpResult.push(vehicle);
		}
	});
	this.stateSvc.setVehicleFiltered(tmpResult);
  }

  coordToGeocode(vhcl){
	if(vhcl.coordinate == vhcl.location){
		this.vehicleSvc.reverseGeocode(vhcl.lat, vhcl.lon)
		.subscribe((res) => {
			if(res && res != ""){
				vhcl.geolocation = res;
				vhcl.location = res;
			}
		});
	}
  }

}
